module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_vm._v("\n  \tDocuments Privés\n\t\t"), _c('div', {
    staticClass: "ctn-docs row"
  }, _vm._l((_vm.docs), function(doc, key) {
    return _c('tile-doc', {
      key: key,
      attrs: {
        "doc": doc
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-485347cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Documents/PrivateDocs.vue
// module id = 1119
// module chunks = 0